import { useAuth } from "../../contexts/AuthContext";
import { useHistory } from "react-router-dom";

export default function Dashboard() {
  const { currentUser, isAdmin } = useAuth();
  const history = useHistory();

  if (!currentUser) {
    history.push("/signup");
  } else {
    history.push("/profile");
  }

  return <></>;
}
